<app-whatsapp-button></app-whatsapp-button>
<!-- INÍCIO -->
<div class="container">
    <div class="row justify-content-center">
        <div class="col-12 col-lg-6">
            <h1 [innerHTML]="pageTitle">Atendimento - Pagmob</h1>
            <p>Selecione a categoria do atendimento.</p>
        </div> <!-- /col -->
    </div> <!-- /row -->

    <div class="row justify-content-center">
        <div class="col-12 col-lg-6" [ng2-loading]="showSpinner">

            <div class="form-panel form-panel-lg">
                <header class="row">
                    <div class="col">
                        <h2>Serviço desejado</h2>
                    </div>
                </header>

                <form>
                    <div class="form-group" style="display: none;">
                        <label for="agencias">Estado</label>
                        <select class="js-example-basic-single form-control" name="agencias" [(ngModel)]="agenciaSelecionada" (ngModelChange)="alterarServico()" id="agencias">
                            <option *ngFor="let agencia of agencias" [value]="agencia.id">{{agencia.description}}
                            </option>
                        </select>
                    </div> <!-- form group -->
                    <div class="form-group">
                        <label for="tipoServicos">Selecione um tipo</label>
                        <select class="js-example-basic-single form-control" name="tipoServicos" [(ngModel)]="tipoServicoSelecionado" (ngModelChange)="alterarTipoServico()" id="tipoServicos">
                            <option *ngFor="let tipoServico of tipoServicos" [value]="tipoServico.id">{{tipoServico.description}}
                            </option>
                        </select>
                    </div> <!-- form group -->
                </form>
            </div> <!-- /form-panel card -->

            <div class="my-4" *ngIf="servicos">
                <h2>Selecione um serviço</h2>
                <ul class="option-list">
                    <a *ngFor="let servico of servicos" (click)="selecionarServico(servico)">
                        <li [ngClass]="{'servicoSelecionado' : servico == servicoSelecionado }">
                            <h4>{{ servico.serviceName }}</h4>
                            <p>{{ servico.serviceDescription }}</p>
                        </li>
                    </a>
                    <li *ngIf="servicos && servicos.length == 0">
                        <h4>Nenhum serviço localizado</h4>
                        <p>Selecione acima outra opção</p>
                    </li>
                </ul>

            </div>

            <div class="form-panel my-4" *ngIf="abertosServicoSelecionado && abertosServicoSelecionado.length">
                <header><h2><img src="assets/icons/warning.svg"> Existem protocolos em aberto para o serviço selecionado</h2></header>
                <div *ngFor="let agendamento of abertosServicoSelecionado">
                    <hr>
                    <h3><span *ngIf="agendamento.appointment">Agendamento </span><span *ngIf="!agendamento.appointment">Solicitação</span> #{{ agendamento.protocol }}</h3>

                    <div *ngIf="!agendamento.appointment">
                      <div>
                        <span>Data da Solicitação: {{ agendamento.selectedDate | date: 'dd/MM/yyyy HH:mm' : 'UTC-03:00' }}</span>
                      </div>
                    </div>

                  <div *ngIf="agendamento.appointment">
                    <div><span>Local: {{ agendamento.serviceLocation }}</span></div>
                    <div><span>Endereço: {{ agendamento.locationAddress }}</span></div>
                    <div>
                      <span>Data de Agendamento: {{ agendamento.selectedDate | date: 'dd/MM/yyyy HH:mm' : 'UTC-03:00' }}</span>
                    </div>
                  </div>
                </div>
                <footer class="card-status" style="text-align: center;">Volte para ver mais informações de todos seus protocolos</footer>
            </div>
        </div> <!-- /col -->
    </div> <!-- /row -->

    <div class="row justify-content-center">
        <div class="col-lg-6">

            <div class="row">
                <div class="col-6">
                    <a [routerLink]="['/app/dashboard']"class="btn btn-primary btn-block">Voltar</a>
                </div>
                <div class="col-6">
                    <button [disabled]="abertosServicoSelecionado && abertosServicoSelecionado.length > 0" *ngIf="servicoSelecionado != null"  class="btn btn-primary btn-block" (click)="avancar()">Próximo</button>
                </div>
            </div> <!-- /row -->

        </div> <!-- /col -->
    </div> <!-- /row -->

</div> <!-- /container -->
<!-- INÍCIO -->
